<template>
    <div class="CompanySidebar">
        <div class="sidebar" :class="{open: isOpen}">
            <div class="header">
                <router-link to="/company/dashboard" class="logoContainer">
                    <Logo class="white"/>
                </router-link>
            </div>

            <div class="main">
                <div class="nav">
                    <router-link
                        v-for="page in pages"
                        :key="page"
                        :class="{ disabled: isDisabled  }"
                        :to="`/company/${page}`"
                    >
                        {{ page }}
                    </router-link>
                </div>

                <div class="nav">
                    <router-link v-if="user.role === 'admin'" to="/company/admin">Company Settings</router-link>
                    <router-link to="/company/settings">Settings</router-link>
                </div>
            </div>
        </div>

        <div class="overlay" :class="{open: isOpen}" @click="toggle"></div>
    </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import Logo from '@/components/Logo';

export default {
    name: 'CompanySidebar',

    components: { Logo },

    data: () => ({
        isOpen: false,
        pages: [
            'dashboard',
            'clients',
            'projects',
            'tickets',
            'materials',
            'vehicles',
            'drivers',
            'managers',
            'reports',
        ],
    }),

    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('company', ['subscriptionSuspended']),

        isDisabled() {
            return this.subscriptionSuspended && this.user.role !== 'admin';
        },
    },

    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CompanySidebar {
    @extend %dashboard-sidebar;
}
</style>
